import { render } from "./mvt-propertymarker.vue?vue&type=template&id=4a1e5b8c"
import script from "./mvt-propertymarker.js?vue&type=script&lang=js"
export * from "./mvt-propertymarker.js?vue&type=script&lang=js"

import "./mvt-propertymarker.vue?vue&type=style&index=0&id=4a1e5b8c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__